import Vue from 'vue'
import Router from 'vue-router'
const Controls2d =() => import('../views/ThreedControls2D')
const Controls3d =() => import('../views/ThreedControls3D')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'controls2d',
      component: Controls2d
    },
    {
      path: '/controls3d',
      name: 'controls3d',
      component: Controls3d
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js